import type * as React from "react";

import { cn } from "@/lib/utils";

/**
 * A placeholder sized like the thing it stands in for. Squared to the deck's
 * 2px, on the recessed stock, and it pulses rather than shimmering — a
 * diagonal sweep is decoration, and this file's whole job is to not be
 * noticed.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-[2px] bg-sunk", className)}
      {...props}
    />
  );
}

export { Skeleton };
